import React, { useCallback, useEffect, useState } from "react";
import GiftCardTable from "../../components/DataTable/GiftCardTable";
import Pagination from "../../components/Pagination";
import instance from "../../axios";
import BarLoading from "../../components/Loaders/BarLoading";
import { getUserToken } from "../../utils/userAuthenticate";
// import useAuthenticate from "../../hooks/useAuthenticate";
import useScrollTop from "../../hooks/useScrollTop";

import { useTranslation } from "react-i18next";
import "../../localisation/index"

const GiftCardsList = () => {
  const {t} = useTranslation()
  // const { getUserToken } = useAuthenticate();

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  // fetch card data
  const updateData = async () => {
    setIsLoading(true);
    const url = `/giftcard/products/list?limit=10&page=${currentPage}`;
    const headers = {
      Authorization: getUserToken(),
    };

    try {
      const res = await instance.post(url, {}, { headers });
      const resData = await res.data;
      setData(resData);
    } catch (error) {
      console.log(error);
    }

    setIsLoading(false);
  };

  // delete card
  const deleteItem = async (id) => {
    const url = "/giftcard/products/delete";
    const body = {
      product_id: id.toString(),
    };
    const headers = {
      Authorization: getUserToken(),
    };

    const res = await instance.post(url, body, { headers });

    updateData();
  };

  useScrollTop();

  useEffect(() => {
    updateData();
  }, [currentPage]);

  return (
    <div className="giftcard-sku__container component">
      {isLoading ? (
        <BarLoading />
      ) : (
        <>
          <div className="component-primary-heading">{t("giftCardList.gcSku")}</div>

          <GiftCardTable data={data?.data} deleteItem={deleteItem} />

          <Pagination
            total={data.count}
            perPage={10}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
        </>
      )}
    </div>
  );
};

export default GiftCardsList;
